var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84578 22.2614C10.3592 22.2614 10.7754 21.8452 10.7754 21.3317C10.7754 20.8183 10.3592 20.4021 9.84578 20.4021C9.33235 20.4021 8.91614 20.8183 8.91614 21.3317C8.91614 21.8452 9.33235 22.2614 9.84578 22.2614Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0719 22.2614C20.5853 22.2614 21.0015 21.8452 21.0015 21.3317C21.0015 20.8183 20.5853 20.4021 20.0719 20.4021C19.5584 20.4021 19.1422 20.8183 19.1422 21.3317C19.1422 21.8452 19.5584 22.2614 20.0719 22.2614Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40869 2.73877H6.12728L8.61873 15.1867C8.70374 15.6147 8.93658 15.9992 9.27649 16.2728C9.61641 16.5465 10.0417 16.6918 10.478 16.6835H19.5142C19.9505 16.6918 20.3758 16.5465 20.7157 16.2728C21.0556 15.9992 21.2885 15.6147 21.3735 15.1867L22.8609 7.387H7.05692",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic_cart.defebc268e10a424d9bd72bf45a7623f.svg";
export { ForwardRef as ReactComponent };